import { render, staticRenderFns } from "./BlockImageRightTextLeftGrayBackground.vue?vue&type=template&id=24fdc3b4&"
import script from "./BlockImageRightTextLeftGrayBackground.vue?vue&type=script&lang=js&"
export * from "./BlockImageRightTextLeftGrayBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports